<template>
  <div>
    <DialogBase
      v-model="inputedValue.dialog"
      :title="$t('common.input_personal-info-setting')"
      width="510"
      isPadding0="true"
    >
      <v-card class="content">
        <div class="photo">
          <input
            style="display: none"
            @change="formatSelectedFile()"
            ref="input"
            type="file"
            name="file"
          />
          <div style="position: relative" @click="triggerFormatSelectedFile">
            <v-img class="photo-img" :src="getImage" />
            <v-icon class="photo-camera">{{ 'mdi-camera' }}</v-icon>
          </div>
        </div>
        <v-row no-gutters align="center">
          <v-col>
            <InputFormNew
              v-model="inputData"
              :detail="detail"
              rowHeight="32px"
              :titleCols="3"
              :contentsCols="9"
            >
              <template #email="{ item }">
                <font color="#999999">{{ `${item.email} ` }}</font>
                <NormalLink
                  v-if="item.email && !isFetching"
                  :text="$t('user.user_change')"
                  link="/user/password-reset-mail?type=email"
                />
              </template>
              <template #password>
                <NormalLink
                  v-if="!isFetching"
                  :text="$t('user.user_change')"
                  :isBlank="true"
                  link="/reset-password"
                />
              </template>
            </InputFormNew>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <NormalButton
              :text="$t('common.input_save')"
              height="50px"
              textSize="16px"
              @click="submit"
            />
          </v-col>
        </v-row>
      </v-card>
    </DialogBase>
    <DialogAlertSuccess
      v-model="completeDialog"
      :text="$t('user.user_personal-info-setting-have-been-saved')"
      width="470px"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { masterUtil, countryCallingCodeUtil } from '@/util'
import DialogBase from './DialogBase'
import { NormalLink } from '@/components/items'
import NormalButton from '@/components/items/Buttons/NormalButton'
import InputFormNew from '@/components/items/Designs/InputFormNew'
import DialogAlertSuccess from '@/components/layouts/Dialogs/DialogAlert/DialogAlertSuccess'
import { fileUploadFileType } from '@/config'

export default {
  components: {
    DialogBase,
    NormalLink,
    NormalButton,
    InputFormNew,
    DialogAlertSuccess
  },
  props: {
    value: {
      dialog: false
    }
  },
  data: () => ({
    isFetching: false,
    inputItemHeight: '32px',
    inputData: {},
    detail: [
      {
        name: 'email',
        text: 'common.input_mailaddress'
      },
      {
        name: 'password',
        text: 'common.input_password'
      },
      {
        name: 'name',
        text: 'common.input_name',
        component: 'NameTextBoxArea',
        required: true
      },
      {
        name: 'phone',
        text: 'common.input_phone-number',
        component: 'PhoneNumberInput'
      },
      {
        name: 'section',
        text: 'user.user_affiliation-secction'
      },
      {
        name: 'position',
        text: 'user.user_job-title'
      }
    ],
    completeDialog: false,
    uploadFile: null
  }),
  created() {},
  methods: {
    ...mapActions('User', ['getUserInfoFromApi', 'registerUserPrivateInfo']),
    ...mapActions('FileStore', ['fileUpload']),
    ...mapGetters('Common', ['getCountryCallingCodeJpFromState']),
    ...mapGetters('User', ['getUserInfoFromState']),

    async init() {
      this.inputData = this.initialInputData
      this.startFetch()
      await this.getUserInfoFromApi().then((message) => {
        this.createData({ loginUser: message.data })
        this.stopFetch()
      })
    },
    startFetch() {
      this.isFetching = true
    },
    stopFetch() {
      this.isFetching = false
    },
    createData({ loginUser = null }) {
      this.inputData = loginUser
        ? {
            email: loginUser.email,
            name: {
              lastName: loginUser.lastName,
              firstName: loginUser.firstName
            },
            authority: this.getAuthority(loginUser.authorityId),
            section: loginUser.section,
            position: loginUser.position,
            phone: {
              countryCode: !loginUser.phoneNumberCountryCode
                ? this.getCountryCallingCodeJpFromState()
                : countryCallingCodeUtil.getPhoneNumberInfoById(
                    loginUser.phoneNumberCountryCode
                  ),
              phoneNumber: loginUser.phoneNumber
            },
            iconImgUrl: loginUser.iconImgUrl ? loginUser.iconImgUrl : ''
          }
        : this.initialInputData
    },
    getAuthority(id) {
      return masterUtil.getAuthorityList().find((ele) => id === ele.value)
    },
    async submit() {
      if (this.isFetching) {
        return
      }
      if (confirm(this.$t('common.common_save-question'))) {
        this.startFetch()
        if (this.uploadFile) {
          const formData = new FormData()
          formData.append('uploadFile', this.uploadFile)
          const uploadData = await this.fileUpload(formData)

          // ファイルアップロード失敗で処理終了
          if (!uploadData) {
            this.stopFetch()
            return
          }

          this.inputData.iconImgUrl = uploadData.data
        }
        const { phone } = this.inputData
        const { countryCode } = phone
        const params = {
          lastName: this.inputData.name.lastName,
          firstName: this.inputData.name.firstName,
          section: this.inputData.section,
          position: this.inputData.position,
          phoneNumberCountryId: countryCode.value,
          phoneNumber: phone.phoneNumber,
          iconImgUrl: this.inputData.iconImgUrl
        }
        this.completeDialog = await this.registerUserPrivateInfo(params)
        this.stopFetch()
      }
    },
    triggerFormatSelectedFile() {
      if (this.isFetching) {
        return
      }
      this.$refs.input.click()
    },
    formatSelectedFile() {
      this.uploadFile = this.$refs.input.files[0]
      if (!this.uploadFile) {
        return
      }
      const approvedType = fileUploadFileType.APPROVE_UPLOAD_IMAGE_FILE_TYPE
      const hasApproved = approvedType.includes(this.uploadFile.type)
      if (!hasApproved) {
        alert(this.$t('common.common_not-approved-file-type'))
        return
      }

      const uploadFileUrl = URL.createObjectURL(this.uploadFile)
      this.inputData.iconImgUrl = uploadFileUrl
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    getImage() {
      return this.inputData.iconImgUrl
        ? this.inputData.iconImgUrl
        : require('../../../assets/icon_user_default.png')
    },
    initialInputData() {
      return {
        email: '',
        name: { lastName: '', firstName: '' },
        authority: {},
        phone: {
          countryCode: '',
          phoneNumber: ''
        },
        section: '',
        position: '',
        iconImgUrl: ''
      }
    }
  },
  watch: {
    inputedValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.dialog) this.init()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 30px !important;
}

.photo {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 0 auto;
  border-radius: 50% !important;
  cursor: pointer;

  &-img {
    border-radius: 50%;
  }

  &-camera {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 34px;
    height: 34px;
    color: #7f7f7f;
    background-color: white;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    border-radius: 50% !important;
  }
}
</style>
